<template>
<b-card header='Order Notes' :header-bg-variant="difference ? 'danger' : ''">
  <b-row>
    <b-col lg=6>
      <p class="font-weight-bold">
        Customer Order Notes
        <data-merger :dict=order.notes title="Order Notes" :hide="true" formatter="htmlify" />
      </p>
      <b-form-textarea plaintext rows=6 :value=orderNotes />
    </b-col>
    <b-col>
      <p class='font-weight-bold'>Order Private Notes</p>
      <b-form-textarea plaintext rows=2 v-if="!!privateNotes" :value=privateNotes />
      <p class='font-weight-bold'>Customer Private Notes</p>
      <b-form-textarea plaintext :rows="!!privateNotes ? 2 : 4" :value=customerNotes />
    </b-col>
  </b-row>
</b-card>
</template>

<script>
import orderMerger from '../../../services/orderMerge'
import DataMerger from '../../utility/DataMerger.vue'

export default {
  props: {
    order: { type: Object, required: true },
  },
  components: {
    DataMerger,
  },
  computed: {
    difference() {
      return orderMerger.fieldDiffers(this.order.notes);
    },
    orderNotesDiffer() {
      return true
    },
    orderNotes() {
      const notes = orderMerger.mergeField(this.order.notes);
      return typeof notes === 'object' ? notes.join('\n\n') : notes
    },
    privateNotes() {
      const notes = orderMerger.mergeField(this.order.orderPrivateNotes);
      return typeof notes === 'object' ? notes.join('\n\n') : notes
    },
    customerNotes() {
      const notes = orderMerger.mergeField(this.order.customerPrivateNotes);
      return typeof notes === 'object' ? notes.join('\n\n') : notes
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/OrderNotes.vue